import { addDays, addSeconds, format, formatISO } from 'date-fns';
import { isString } from 'lodash-es';

import { DATE_WITH_TIMEZONE_FORMAT } from '@iconik-io/core/src/date/date_formats';

import type { DateRange, DateRangeValue } from '../ui/calendar/default_options';
import relativeTimeToDate from '../ui/calendar/relative_time_to_date';

const resolveRelativeDate = (value: DateRangeValue): DateRangeValue =>
  isString(value) && value.startsWith('now')
    ? formatISO(relativeTimeToDate(value))
    : value;

const formatDateAsRange = (value: DateRange | string): string => {
  if (!value) {
    return '';
  }
  // convert value always to range
  if (isString(value)) {
    return `${value};${format(
      addSeconds(addDays(new Date(value), 1), -1),
      DATE_WITH_TIMEZONE_FORMAT,
    )}`;
  }
  if (value.min && value.max) {
    return `${resolveRelativeDate(value.min)};${resolveRelativeDate(value.max)}`;
  }
  return '';
};

export default formatDateAsRange;
